<template>
    <div class="mainpage">
        <div class="domain-ref">
            <div class="heading">
                Steps to add custom domain
            </div>
            <div>
                This text refers to the step by step procedure to add the custom domain and custom subdomain to the portal.  Steps to Configure the DNS records and other required information. Server Ips will be shown here for DNS configuration.
            </div>
            <div>
                For subdomain configuration, point the CNAME record to cname.{{ defaultDomain }}
            </div>
        </div>
        <div class="d-flex justify-content-end my-3">
            <Button icon="pi pi-plus" label="Create New" @click="addDomain"/>
        </div>
        <div class="custom-table">
            <DataTable class="p-datatable" :value="getDomains" tableStyle="min-width: 50rem"
                paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]"
                paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            >
                <template #empty>
                    <div class="empty-state"><img class="empty-state-image" src="@/assets/images/empty-state.svg"/></div>
                    <div class="empty-state">No data available</div>
                </template>
                <Column field="Domain" header="Short Domain"></Column>
                <Column field="Status" header="Verification Status">
                    <template #body="slotProps">
                        {{ domainStatusMap[slotProps.data.Status] }}
                    </template>
                </Column>
                <Column field="LastUpdated" header="Updated On"></Column>
            </DataTable>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import { domainStatusMap } from '@/constants'
import config from '@/config/config'

export default {
    name: 'Domains',
    components: {
    },
    data () {
        return {
            domainStatusMap,
            defaultDomain: config.DEFAULT_DOMAIN
        }
    },
    methods: {
        async addDomain () {
            this.$router.push('/domain/create')
        },
        async getDomainsList () {
            this.globalLoader = true
            await this.$store.dispatch('Domains/Domain/fecthDomains')
            this.globalLoader = false
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapGetters({ currentUser: 'currentUser' }),
        ...mapGetters('Domains/Domain/', ['getDomains'])
    },
    async mounted () {
        await this.getDomainsList()
    }
}
</script>

<style>
.domain-ref {
    background-color: white;
    border-radius: 10px;
    padding: 1rem;
}
.heading {
    font-weight: 700;
    margin-bottom: 0.5rem;
}
</style>
